export function isSpecialKeyPressed(event: MouseEvent | KeyboardEvent) {
	return event.ctrlKey || event.metaKey || event.altKey || event.shiftKey
}
